import cn from 'classnames/bind';
import React, { useEffect, useRef, useState } from 'react';
import { Text } from '@consta/uikit/Text';
import styles from './styles.styl';
import { IconArrowDown } from '@consta/uikit/IconArrowDown';
import { Button } from '@consta/uikit/Button';
import { IconForward } from '@consta/uikit/IconForward';
import { useMediaQuery } from 'react-responsive';

import {
  IFiles,
  IVersionType,
} from 'src/redux/features/methodModels/allModels/types';
import { formatDate } from 'src/utils';
import { heightTextCard } from 'src/utils/config';
import { CardModalPropType } from 'src/utils/type';

const cx = cn.bind(styles);

export interface ICardModalProps {
  id: string;
  title: string;
  text: string;
  dateChange: string;
  dateLast: string;
  version: IVersionType[];
  image: IFiles[];
  isMyModal: boolean;
  type: number;
  url: string;
  manual: string;
  handleClickModal?: (info: CardModalPropType) => void;
  handleClickRunning?: (info: CardModalPropType) => void;
  className?: string;
}

const CardModal: React.FC<ICardModalProps> = ({
  id,
  title,
  text,
  dateChange,
  dateLast,
  version,
  image,
  type,
  url,
  manual,
  handleClickModal = () => {},
  handleClickRunning = () => {},
  className,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 460 });

  const textRef = useRef(null);

  const newItem = {
    id,
    title,
    text,
    dateChange,
    dateLast,
    version,
    image,
    type,
    url,
    manual,
  };

  const [isOpenCard, setIsOpenCard] = useState(false);

  const [isClamp, setIsClamp] = useState(false);

  useEffect(() => {
    if (textRef?.current) {
      if (textRef.current.offsetHeight > heightTextCard.dekstop && !isMobile) {
        setIsClamp(true);
      } else if (
        textRef.current.offsetHeight > heightTextCard.mobile &&
        isMobile
      ) {
        setIsClamp(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={cx('CardModal', className)}>
      <div className={cx('CardModal__header')}>
        <div
          onClick={() => handleClickModal(newItem)}
          className={cx('CardModal__titleContainer')}
        >
          <div
            className={cx('CardModal__imageContainer', {
              CardModal__imageContainer_bgr: !image.length,
            })}
          >
            {!!image.length && (
              <img
                className={cx('CardModal__image')}
                src={`${process.env.REACT_APP_STATIC_URL}/${image[0].path}`}
              />
            )}
          </div>
          {!isMobile && (
            <div className={cx('CardModal__titleContent')}>
              <Text className={cx('CardModal__title')}>{title}</Text>
              {!!version.length && (
                <Text view={'secondary'} size="s">
                  {`Версия ${version[0]?.version}`}
                </Text>
              )}
            </div>
          )}
        </div>
        <div className={cx('CardModal__dateChange')}>
          <Text size="s" lineHeight="l" view="secondary">
            {'Дата изменения'}
          </Text>
          <Text
            size="xs"
            lineHeight="l"
            view="secondary"
            className={cx('CardModal__dateChangeText')}
          >
            {formatDate(dateChange)}
          </Text>
        </div>
      </div>
      {isMobile && (
        <div onClick={() => handleClickModal(newItem)}>
          <Text className={cx('CardModal__title')}>{title}</Text>
          {!!version.length && (
            <Text
              className={cx('CardModal__version')}
              view={'secondary'}
              size="s"
            >
              {`Версия ${version[0]?.version}`}
            </Text>
          )}
        </div>
      )}
      <div className={cx('CardModal__content')}>
        <div
          className={cx('CardModal__containerText', {
            CardModal__containerText_active: isOpenCard,
            CardModal__containerText_clamp: isClamp,
          })}
          ref={textRef}
        >
          <Text size="s" view="secondary" className={cx('CardModal__text')}>
            {text}
          </Text>
        </div>
        {isClamp && (
          <div className={cx('CardModal__arrowDown')}>
            <IconArrowDown
              className={cx('CardModal__arrowText', {
                CardModal__arrowText_active: isOpenCard,
              })}
              onClick={() => setIsOpenCard((prev) => !prev)}
            />
          </div>
        )}
      </div>
      <div className={cx('CardModal__launch')}>
        {dateLast && (
          <div className={cx('CardModal__dateLast')}>
            <Text
              className={cx('CardModal__dateLastText')}
              size="s"
              lineHeight="l"
              view="secondary"
            >
              {'Дата последнего запуска'}
            </Text>
            <Text
              className={cx('CardModal__dateLastText')}
              size="s"
              lineHeight="l"
            >
              {formatDate(dateLast)}
            </Text>
          </div>
        )}
        <Button
          label={'Запустить'}
          size={isMobile ? 'xs' : 's'}
          iconRight={IconForward}
          iconSize="xs"
          view="ghost"
          onClick={() => handleClickRunning(newItem)}
          className={cx('CardModal__launchButton')}
        />
      </div>
    </div>
  );
};

export default CardModal;
